import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

export const Route = createFileRoute("/app/admin/fsm/entities/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
